module.exports = __webpack_public_path__ + "static/media/analysis-dark.b0bd2ede.png";